import _constant from 'BASE/common/lotteryConstant';
import _datetime from 'BASE/common/util/util.dateTime';

export const DecimalPrecision = _constant.DecimalPrecision;
export const FinancialDay = _datetime.getFinancialDayDelimitation();
export const ActivityType = _constant.ActivityType;
export const AgentActivityRecordType = _constant.AgentActivityRecordType;
export const ActivityRepeatable = _constant.ActivityRepeatable;
export const BetRequiredItem = _constant.BetRequiredItem;
export const ActivityResult = _constant.ActivityResult;
export const ActivityResultStr = _constant.ActivityResultStr;
export const ActivityReceiveResult = _constant.ActivityReceiveResult;
export const RewardState = _constant.RewardState;
export const TeamRedPackRainType = _constant.TeamRedPackRainType;
export const TeamActivityMode = _constant.TeamActivityMode;
export const OneDollarActivityGetGifType = _constant.OneDollarActivityGetGifType;

export const SystemState = {
    AJAX_FAILED: '提交失败请重新尝试',
    SUCCESS: '设定成功',
    FAILED: '设定失败',
    INVALID_PARAM: '参数错误',
    FREQUENT_EXECUTION: '建立活动操作频繁,请稍后再尝试',
    UPDATE_WALLET_ERROR: '建立活动更新钱包失败',
    NOT_ENOUGH_MONEY: '资金不足'
}

export const RewardBtnState = {
    ALLOW: '可领取',
    NOT_ALLOW: '不可领取',
    RECEIVED: '已领取',
    ALL_RECEIVED: '已领取完毕',
    EXPIRED: '已过期',
    DOUBLE_SUBMIT: '重复提交，请稍后重试',
};
